import React from 'react';
import "./Packaging.css";
import images from '../../Asset/Img/img';

function Packaging() {
  return (
    <div className='packaging-container'>
      <div className='packaging-content'>
        <div className='packaging-header'>

          <div className='packaging-header-text'>
            <h4>PAKETLEME</h4>
          </div>
        </div>

        <div className='packaging-middle'>
          <h2>High PCK transfer ve kullanım açısından üretim sürecinize uygun paketleme seçenekleri sunar.</h2>



          <div className='packaging-box-container'>

            <div className='box-item box-item-one'>
              <div className='box-item-img-container'>
                <img src={images.packetOne} alt="packet-icon" />
              </div>
              <div className='box-item-content'>
                <strong>PRE-CUT-WIG-WAG-STRIPS</strong>
                <p>Pre-cut stripes, wig waag packed on pallets.</p>
                <strong>SIZE</strong>
                <li>Breadth from min. 50 mm to max. 320 mm</li>
                <li>Thickness 8-10 mm</li>
              </div>
            </div>

            <div className='box-item box-item-two'>
              <div className='box-item-img-container'>
                <img src={images.packetTwo} alt="packet-icon" />
              </div>
              <div className='box-item-content'>
                <strong>COILS</strong>
                <p>Single strip rolled up on a plastic rol..</p>
                <strong>SIZE</strong>
                <li>Breadth about 40 mm</li>
                <li> Variable length (for about 10 kg total weight for each coil)</li>
                <li>Thickness 8-10 mm</li>
              </div>
            </div>

            <div className='box-item box-item-three'>
              <div className='box-item-img-container'>
                <img src={images.packetThree} alt="packet-icon" />
              </div>
              <div className='box-item-content'>
                <strong>ENDLESS STRIP</strong>
                <p>Continious strip cut directly by the mill.</p>
                <strong>SIZE</strong>
                <li> Breadth from min. 80 mm to max. 400 mm</li>
                <li>Thickness 8-10 mm</li>
              </div>
            </div>

            <div className='box-item box-item-four'>
              <div className='box-item-img-container'>
                <img src={images.packetFour} alt="packet-icon" />
              </div>
              <div className='box-item-content'>
                <strong>WIG WAG STRIP</strong>
                <p>Continious wig wag strip packed on a pallet.</p>
                <strong>SIZE</strong>
                <li>Breadth from min. 300 mm to max. 750 mm</li>
                <li>Thickness 8-10 mm</li>
              </div>
            </div>

            <div className='box-item box-item-five'>
              <div className='box-item-img-container'>
                <img src={images.packetFive} alt="packet-icon" />
              </div>
              <div className='box-item-content'>
                <strong>CONTINIOUS STRIP</strong>
                <p>Produced by extrusion, passing through anti-tack bath and finally packed onto a pallet or into a box.</p>
                <strong>SIZE</strong>
                <li>Breadth from min. 30 mm to max. 180 mm</li>
                <li>Thickness 8-10 mm</li>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  )
}

export default Packaging